module.exports = __webpack_public_path__ + "img/gb-whatsapp-for-pc.29e25e2e.webp";